import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AgentPersonalDetailResponse } from '@models/AgentPersonalDetailRequest.model';
import { MyInfoForm, MyInfoAddressForm } from '@models/SIO/MyInfo.model';
import { MyInfoPersonResponse, AddMyInfoRequest } from '@models/MyInfoRequest.model';
export interface Step2State {
  personalDetails: AgentPersonalDetailResponse | null;
  myInfoForm: MyInfoForm | null;
  myInfoAddressForm: MyInfoAddressForm | null;
  retrievedMyInfo: MyInfoPersonResponse | null;
  addMyInfoPopup: AddMyInfoRequest | null;
  addMyInfoResponse: any;
  hasMyInfo: boolean;
  isCompleted: boolean;
  l400: any;
  myInfoRawResponse: any;
}

const initialState: Step2State = {
  personalDetails: null,
  myInfoForm: new MyInfoForm(null),
  myInfoAddressForm: null,
  retrievedMyInfo: null,
  addMyInfoPopup: null,
  addMyInfoResponse: null,
  hasMyInfo: false,
  isCompleted: false,
  l400: null,
  myInfoRawResponse: null
}

const step2Slice = createSlice({
  name: 'SIO-Step2',
  initialState,
  reducers: {
    updatePersonalDetails: (state, action: PayloadAction<AgentPersonalDetailResponse>) => {
      state.personalDetails = action.payload
    },
    updateMyInfoForm: (state, action: PayloadAction<MyInfoForm>) => {
      state.myInfoForm = action.payload
    },
    updateMyInfoAddressForm: (state, action: PayloadAction<MyInfoAddressForm>) => {
      state.myInfoAddressForm = action.payload
    },
    updateRetrievedMyInfo: (state, action: PayloadAction<MyInfoPersonResponse>) => {
      state.retrievedMyInfo = action.payload
    },
    updateAddMyInfoPopup: (state, action: PayloadAction<AddMyInfoRequest>) => {
      state.addMyInfoPopup = action.payload
    },
    updateAddMyInfoResponse: (state, action: PayloadAction<any>) => {
      state.addMyInfoResponse = action.payload
    },
    updateHasMyInfo: (state, action: PayloadAction<boolean>) => {
      state.hasMyInfo = action.payload
    },
    completeStep: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    },
    updateL400: (state, action: PayloadAction<any>) => {
      state.l400 = action.payload
    },
    updateMyInfoRawResponse: (state, action: PayloadAction<any>) => {
      state.myInfoRawResponse = action.payload
    },
  },
  extraReducers: {}
})

export const { 
  updateMyInfoRawResponse, 
  updatePersonalDetails,
  updateMyInfoForm,
  updateMyInfoAddressForm,
  updateRetrievedMyInfo,
  updateAddMyInfoPopup,
  updateAddMyInfoResponse,
  updateHasMyInfo,
  updateL400,
  completeStep
} = step2Slice.actions;

export default step2Slice.reducer;